import type { CheckPermissionFn } from '@/components/InvoiceReportDetailDrawer/type';
import { FC, PropsWithChildren, createContext, useContext } from 'react';

const InvoiceReportsSearchContext = createContext<
  CheckPermissionFn | undefined
>(undefined);

type TValue<T extends Function> = {
  value: T;
};

export const InvoiceReportsSearchRefetchProvider: FC<
  PropsWithChildren<TValue<CheckPermissionFn>>
> = ({ children, value }) => {
  return (
    <InvoiceReportsSearchContext.Provider value={value}>
      {children}
    </InvoiceReportsSearchContext.Provider>
  );
};

export const useInvoiceReportsSearchRefetch = ():
  | CheckPermissionFn
  | undefined => useContext(InvoiceReportsSearchContext);
